export default __webpack_public_path__ + "static/media/mysteryBetLogo.4c871603.svg";